/*
 * Desktop - Side Cart - Tier-Aware BNPL Messaging  --  variant: Replace BNPL Row
 * Moonshot experiment id: oHnffSjpN9KJrW5bg4VkMb   status in Moonshot on 2026-08-27: RUNNING   started: 2026-08-17
 * Audience: DESKTOP   Target: side_cart   (see MGExp.targets in mg-exp-runtime.js)
 * Source: verbatim variant code from cdn.moonshot-ai.com/snippets/36780565.js (prettified);
 *         only change is window.msaiTools._msaiRunVariantBlock -> MGExp.runVariantBlock.
 * Enabled by theme setting: mgexp_sc_d_bnpl_replace_row
 */
MGExp.run('sc_d_bnpl_replace_row', { name: "Desktop - Side Cart - Tier-Aware BNPL Messaging / Replace BNPL Row", platform: 'desktop', target: 'side_cart' }, function () {
  !(function () {
    let t = [],
      e = [];
    const i = {
      classify: function (t) {
        return t <= 0
          ? null
          : t < 1e5
            ? "A"
            : t < 25e4
              ? "B"
              : t < 1e6
                ? "C"
                : t < 175e4
                  ? "D"
                  : "E";
      },
      copy: {
        A: {
          providers:
            "ShopPay, Affirm, Afterpay, and Klarna — pay in 4 interest-free.",
          caveat: "Subject to credit approval. See provider terms at checkout.",
          ctaText: "Prequalify with Affirm in 30 seconds →",
        },
        B: {
          providers:
            "Affirm Monthly, Klarna Financing, or Afterpay (near limit).",
          caveat:
            "Pay-in-4 plans not available at this cart total. Subject to credit approval.",
          ctaText: "Prequalify with Affirm in 30 seconds →",
        },
        C: {
          providers:
            "Affirm Monthly or Klarna Financing — split into monthly payments.",
          caveat:
            "Pay-in-4 and Afterpay not available at this cart total. Subject to credit approval.",
          ctaText: "Prequalify with Affirm in 30 seconds →",
        },
        D: {
          providers:
            "Affirm Monthly or Shop Pay Installments — extended financing available.",
          caveat: "Subject to credit approval at checkout.",
          ctaText: "See if you qualify with Affirm →",
        },
        E: {
          providers:
            "Affirm Monthly extended financing for high-value purchases.",
          caveat: "Prequalification required for cart totals at this level.",
          ctaText: "Apply for Affirm financing →",
        },
      },
    };
    let n = null;
    function a(t) {
      const e = i.classify(t);
      if (!e) return null;
      const n = i.copy[e],
        a = document.createElement("div");
      a.className = "msai-bnpl-tier";
      const o = document.createElement("strong");
      ((o.className = "msai-bnpl-tier-heading"),
        (o.textContent = "Buy Now, Pay Later"),
        a.appendChild(o));
      const r = document.createElement("button");
      return (
        (r.type = "button"),
        (r.className = "msai-bnpl-tier-prequal"),
        r.setAttribute("aria-label", n.ctaText.replace(" →", "")),
        r.setAttribute("data-msai-amount-cents", String(t)),
        (r.textContent = n.ctaText),
        r.addEventListener("click", (e) => {
          e.preventDefault();
          const i = e.currentTarget,
            n = i.textContent;
          ((i.disabled = !0), (i.textContent = "Opening Affirm…"));
          (!(function (t) {
            if (
              window.affirm &&
              window.affirm.ui &&
              "function" == typeof window.affirm.ui.openModal
            )
              return void window.affirm.ui.openModal({ amount: t });
            const e = document.querySelector(".affirm-modal-trigger");
            e && e.click();
          })(Number(i.getAttribute("data-msai-amount-cents")) || t),
            setTimeout(() => {
              ((i.disabled = !1), (i.textContent = n));
            }, 4e3));
        }),
        a.appendChild(r),
        a
      );
    }
    function o() {
      const t = document.querySelector(
        ".mc-icons .mc-icon-row:first-child .mc-icon-description",
      );
      if (!t) return;
      const e = document.querySelector(".bag-container [data-cart-total]");
      !(function (t, e) {
        const n = i.classify(e),
          o = t.querySelector(".msai-bnpl-tier");
        (o && o.remove(),
          n
            ? (t.appendChild(a(e)), t.classList.add("msai-bnpl-tier-active"))
            : t.classList.remove("msai-bnpl-tier-active"));
      })(
        t,
        e
          ? (function (t) {
              const e = parseFloat((t || "").replace(/[^\d.]/g, ""));
              return isNaN(e) ? 0 : Math.round(100 * e);
            })(e.textContent)
          : 0,
      );
    }
    !(async function (i, n, a, o, r) {
      let c = {
        multi_target_selectors: t,
        page_identifier_selector: ".bag-container",
        exclude_from_timeout: e,
        selector_timeout: 5e3,
      };
      await MGExp.runVariantBlock(i, n, a, o, r, c);
    })(
      [
        ".mc-icons .mc-icon-row:first-child .mc-icon-description",
        "#mini-cart-summary",
      ],
      ".msai-bnpl-tier-applied",
      function (t, e) {
        const [i, a] = e;
        (o(),
          n && n.disconnect(),
          (n = new MutationObserver(o)),
          n.observe(a, { childList: !0, characterData: !0, subtree: !0 }),
          i.classList.add("msai-bnpl-tier-applied"));
      },
      ".mc-icons .mc-icon-row:first-child .mc-icon-description.msai-bnpl-tier-active > p{display:none}.mc-icons .mc-icon-row:first-child .mc-icon-description.msai-bnpl-tier-active .msai-bnpl-tier{display:block}.msai-bnpl-tier-heading{display:block;font-family:'Raleway',sans-serif;font-size:14px;font-weight:700;color:#000000;margin:0 0 4px 0}.msai-bnpl-tier-providers{display:block;font-family:'Raleway',sans-serif;font-size:13px;font-weight:400;color:#000000;line-height:1.4;margin:0 0 4px 0}.msai-bnpl-tier-caveat{display:block;font-family:'Raleway',sans-serif;font-size:11px;font-weight:400;color:#555555;line-height:1.3;margin:0}.msai-bnpl-tier-prequal{width:100%;display:flex;margin-top:8px;padding:8px 10px;font-family:'Raleway',sans-serif;font-size:12px;font-weight:700;letter-spacing:0.04em;color:#000000;text-decoration:none;background:#FFFFFF;border:1px solid #000000;cursor:pointer;text-align:left;line-height:1.2;transition:background-color 0.15s ease,color 0.15s ease;justify-content:center}.msai-bnpl-tier-prequal:hover{background:#000000;color:#FFFFFF}.msai-bnpl-tier-prequal:focus-visible{outline:2px solid #000000;outline-offset:2px}.msai-bnpl-tier-prequal:disabled{opacity:0.6;pointer-events:none}",
      function () {
        (n && (n.disconnect(), (n = null)),
          document.querySelectorAll(".msai-bnpl-tier").forEach((t) => t.remove()),
          document.querySelectorAll(".msai-bnpl-tier-applied").forEach((t) => {
            (t.classList.remove("msai-bnpl-tier-applied"),
              t.classList.remove("msai-bnpl-tier-active"));
          }));
      },
    );
  })();
});
